import ApiBase from '@/lib/api/v1/api-base'

class Settings extends ApiBase {
  getSettings() {
    return this.transport.get(this.getEndpointUrl('/app/settings'))
  }
}

export default Settings
